import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
//modelos
import { UserStates } from '../models/userstate.model';
import { Question, IQuestion, QuestionUser } from '../models/question.model';
import { UserRoles } from '../models/roles.model';

import {  HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
//comentario
@Injectable({ providedIn: 'root' })
export class UtilitiesService {

  private Url: string;

  private currentListStatesSubject: BehaviorSubject<UserStates[]>;
  private currentListRolesSubject: BehaviorSubject<UserRoles[]>;



  questionList: Question[] = [];
  test: any;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
    this.currentListStatesSubject = new BehaviorSubject<UserStates[]>(JSON.parse(localStorage.getItem('currentUserStates')));
    this.currentListRolesSubject = new BehaviorSubject<UserRoles[]>(JSON.parse(localStorage.getItem('currentuserRoles')));
  }

  public get currentListUserstates(): UserStates[] {
    return this.currentListStatesSubject.value;
  }

  public get currentListUserRoles(): UserRoles[] {
    return this.currentListRolesSubject.value;
  }

  getAllUserStates() {
    return this.http.get<UserStates[]>(this.Url + 'api/states')
      .subscribe(userStates => {
        // Existe algun estado
        if (userStates) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUserStates', JSON.stringify(userStates));
          this.currentListStatesSubject.next(userStates);
        }
        return userStates;
      }, err => { console.log(err) });
  }


  getAllQuestions(): Observable<IQuestion[]> {
    return this.http.get<IQuestion[]>(this.Url + 'api/questions/')
  }

  getAllRoles() {
    return this.http.get<UserRoles[]>(this.Url + 'api/roles/')
      .subscribe(userRoles => {
        // Existe algun estado
        if (userRoles) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentuserRoles', JSON.stringify(userRoles));
          this.currentListRolesSubject.next(userRoles);
        }
        return userRoles;
      }, err => { console.log(err) });
  }

  getQuiestionbyName(nickname: string) {
    let params = new HttpParams().set("nickname", nickname);
    return this.http.get<QuestionUser>(this.Url + 'api/questions/pregunta', { params : params })
  }
}
